// useOSINTTotals.ts
import { useState, useEffect } from 'react';
import { getOSINTTotals, OSINTTotalsResponse } from '../api/countService';

const useOSINTTotals = () => {
  const [totals, setTotals] = useState<OSINTTotalsResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchTotals = async () => {
      try {
        const data = await getOSINTTotals();
        setTotals(data);
      } catch (err) {
        setError('Error al obtener los totales de OSINT');
      } finally {
        setLoading(false);
      }
    };

    fetchTotals();
  }, []);

  return { totals, loading, error };
};

export default useOSINTTotals;
